import { render, staticRenderFns } from "./additional-form.vue?vue&type=template&id=f5974c18&"
import script from "./additional-form.vue?vue&type=script&lang=js&"
export * from "./additional-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports